import http, { authHeader } from './http';

// Получить опубликованные документы (публичный)
export const getDocuments = () =>
  http.get('/api/documents').then((r) => r.data);

// --- Admin-функции ---

export const getAllDocumentsAdmin = (token) =>
  http.get('/api/documents/admin', { headers: authHeader(token) }).then((r) => r.data);

export const createDocument = (token, formData) =>
  http.post('/api/documents/admin', formData, { headers: authHeader(token) }).then((r) => r.data);

export const updateDocument = (token, id, formData) =>
  http.put(`/api/documents/admin/${id}`, formData, { headers: authHeader(token) }).then((r) => r.data);

export const deleteDocument = (token, id) =>
  http.delete(`/api/documents/admin/${id}`, { headers: authHeader(token) }).then((r) => r.data);
